import slide1 from "../images/mainHero/slide-1.jpg";
// import slide3 from "../images/mainHero/slide-3.jpg";
// import slide4 from "../images/mainHero/slide-4.jpg";

import ss2 from "../../assets/images/mainHero/ss2.jpg";
import ss3 from "../../assets/images/mainHero/ss3.jpg";

const mainHerodata = [
  {
    id: 1,
    name: "Nur Alam",
    title: "Shopify E-commerce Expert",
    subtitle: "Shopify Developer",
    image: ss2,
    socials: [
      {
        id: 1,
        name: "facebook",
        icon: "fab fa-facebook-f",
        link: "https://www.facebook.com/nuralam.noyon.5",
      },
      {
        id: 2,
        name: "linkedin",
        icon: "fab fa-linkedin-in",
        link: "https://www.linkedin.com/in/nur-alam-noyon-2835681b8/",
      },
      {
        id: 3,
        name: "github",
        icon: "fab fa-instagram",
        link: "https://www.instagram.com/nur_alam_noyon/",
      },
      {
        id: 4,
        name: "tiktok",
        icon: "fab fa-tiktok",
        link: "https://www.tiktok.com/@nur_alam_noyon?_t=8sF2qJFbgfA&_r=1",
      },
      {
        id: 5,
        name: "twitter",
        icon: "fab fa-twitter",
        link: "https://x.com/nuralamnoyon03",
      },
    ],
  },
  {
    id: 2,
    name: "Nur Alam",
    title: "Shopify E-commerce Development",
    subtitle: "CSV File Expert",
    image: ss3,
    socials: [
      {
        id: 1,
        name: "facebook",
        icon: "fab fa-facebook-f",
        link: "https://www.facebook.com/nuralam.noyon.5",
      },
      {
        id: 2,
        name: "linkedin",
        icon: "fab fa-linkedin-in",
        link: "https://www.linkedin.com/in/nur-alam-noyon-2835681b8/",
      },
      {
        id: 3,
        name: "github",
        icon: "fab fa-instagram",
        link: "https://www.instagram.com/nur_alam_noyon/",
      },
      {
        id: 4,
        name: "tiktok",
        icon: "fab fa-tiktok",
        link: "https://www.tiktok.com/@nur_alam_noyon?_t=8sF2qJFbgfA&_r=1",
      },
      {
        id: 5,
        name: "twitter",
        icon: "fab fa-twitter",
        link: "https://x.com/nuralamnoyon03",
      },
    ],
  },
  {
    id: 3,
    name: "Nur Alam",
    title: "Shopify E-commerce Management",
    subtitle: "Product Listing Expert",
    image: slide1,
    socials: [
      {
        id: 1,
        name: "facebook",
        icon: "fab fa-facebook-f",
        link: "https://www.facebook.com/nuralam.noyon.5",
      },
      {
        id: 2,
        name: "linkedin",
        icon: "fab fa-linkedin-in",
        link: "https://www.linkedin.com/in/nur-alam-noyon-2835681b8/",
      },
      {
        id: 3,
        name: "github",
        icon: "fab fa-instagram",
        link: "https://www.instagram.com/nur_alam_noyon/",
      },
      {
        id: 4,
        name: "tiktok",
        icon: "fab fa-tiktok",
        link: "https://www.tiktok.com/@nur_alam_noyon?_t=8sF2qJFbgfA&_r=1",
      },
      {
        id: 5,
        name: "twitter",
        icon: "fab fa-twitter",
        link: "https://x.com/nuralamnoyon03",
      },
    ],
  },
];

export default mainHerodata;
